export default __webpack_public_path__ + "static/award-logo-1-f1c10ea05ab6876c1c80d11f79be48e6.svg";